import { LatamAboutPage } from '@/screens/Latam/About/LatamAboutPage';

export default function AboutPage() {
  return <LatamAboutPage locale="es-MX" />;
}
